
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

// 编辑新增销售合同
export function updateSalesContract (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/contract/sell',
    method: 'POST',
    data: parameter
  })
}
// 删除合同
export function deleteContract (ids) {
  return axios({
    url: sysInfo.apiRemote + '/contract?ids=' + ids,
    method: 'DELETE'
  })
}
// 获取销售合同列表
export function getSalesContractList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/contracts/sell',
    method: 'GET',
    params: parameter
  })
}
// 新增编辑采购合同
export function updatePurchaseContract (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/contract/purchase',
    method: 'POST',
    data: parameter
  })
}
// 获取采购合同列表
export function getPurchaseContractList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/contract/purchase',
    method: 'GET',
    params: parameter
  })
}
